/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module PoliciesModule
 */

import { ResponseMatchTarget } from 'object-types';
import { IResponseMatchTarget } from 'generated-types';

import { CookieMatchConfigItem }
    from 'ajs/modules/match/factories/cookie-match.config-item.factory';

import { HdrMatchConfigItem }
    from 'ajs/modules/match/factories/hdr-match.config-item.factory';

import { HostHdrMatchConfigItem }
    from 'ajs/modules/match/factories/host-hdr-match.config-item.factory';

import { LocationHdrMatchConfigItem }
    from 'ajs/modules/match/factories/location-hdr-match.config-item.factory';

import { HTTPVersionMatchConfigItem }
    from 'ajs/modules/match/factories/http-version-match.config-item.factory';

import { IpAddrMatchConfigItem }
    from 'ajs/modules/match/factories/ip-addr-match.config-item.factory';

import { MethodMatchConfigItem }
    from 'ajs/modules/match/factories/method-match.config-item.factory';

import { PathMatchConfigItem }
    from 'ajs/modules/match/factories/path-match.config-item.factory';

import { PortMatchConfigItem }
    from 'ajs/modules/match/factories/port-match.config-item.factory';

import { ProtocolMatchConfigItem }
    from 'ajs/modules/match/factories/protocol-match.config-item.factory';

import { QueryMatchConfigItem }
    from 'ajs/modules/match/factories/query-match.config-item.factory';

import { PolicyMatchConfigItem } from './policy-match.config-item.factory';

type TResponseMatchTargetPartial = Omit< IResponseMatchTarget, 'client_ip' | 'cookie' | 'hdrs'
| 'host_hdr' | 'loc_hdr' | 'method' | 'path' | 'protocol' | 'query' | 'rsp_hdrs' | 'source_ip'
| 'version' | 'vs_port'>;

interface IResponseMatchTargetConfig extends TResponseMatchTargetPartial {
    client_ip?: IpAddrMatchConfigItem,
    cookie?: CookieMatchConfigItem
    hdrs?: HdrMatchConfigItem,
    host_hdr?: HostHdrMatchConfigItem,
    loc_hdr?: LocationHdrMatchConfigItem,
    method?: MethodMatchConfigItem,
    path?: PathMatchConfigItem,
    protocol?: ProtocolMatchConfigItem;
    query?: QueryMatchConfigItem;
    rsp_hdrs?: HdrMatchConfigItem;
    source_ip?: IpAddrMatchConfigItem;
    version?: HTTPVersionMatchConfigItem;
    vs_port?: PortMatchConfigItem;
}

/**
 * @desc ResponseMatchTarget MessageItem class.
 * @author Abhinesh Gour
 */
export class ResponseMatchTargetConfigItem extends
    PolicyMatchConfigItem<IResponseMatchTargetConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: ResponseMatchTarget,
            ...args,
        };

        super(extendedArgs);
    }
}
